import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';

import { useAuth } from '../context/AuthContext';

const PricingAdminRoute: React.FC = () => {
  const {
    isLoading,
    hasResolvedPricingAccess,
    isPricingAdmin,
  } = useAuth();

  if (isLoading || !hasResolvedPricingAccess) {
    return (
      <Box
        sx={{
          minHeight: '60vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!isPricingAdmin) {
    // PRC-027: un miembro que abre Mi equipo o Mi suscripción va a Overview.
    return <Navigate to="/margin-center/overview" replace />;
  }

  return <Outlet />;
};

export default PricingAdminRoute;